let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Ne4A")).then(() => parcelRequire('bam0c'));